import { makeStyles } from '@material-ui/core/styles';
import { primaryText } from '../../utils/CssGlobalVariables';

export const useStyle = makeStyles(theme => ({
    paper: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(1250 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(2),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(1250 + theme.spacing(2) * 2)]: {
            width: 1250,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },

    margintop: {
        marginTop: theme.spacing(3),
    },
    marginleft: {
        marginLeft: theme.spacing(1),
    },
    marginbottom3: {
        marginBottom: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            marginBottom: theme.spacing(3),
        },
    },
    checked: {
        '&, & + $label': {
            color: primaryText,
        },
    },
    label: {},

    radioLabel: {
        border: 'solid',
        borderWidth: '1px',
        borderColor: 'darkgrey',
        borderRadius: 25,
        padding: '0px 10px 0px 0px',
        margin: '0px 0px 0px 15px',
        fontSize: '12px',
        [theme.breakpoints.down('sm')]: {
            width: '48%',
            margin: '0px 0px 0px 5px',
            lineHeight: '1.2 !important',
            padding: '5px 0px 5px 1px',
        },
    },

    boldFont: {
        fontFamily: 'gt-walsheim-medium',
        lineHeight: '1.2 !important',
        [theme.breakpoints.down('sm')]: {
            lineHeight: '1.2 !important',
        },
    },
    button: {
        borderRadius: 20,
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-medium',
        fontSize: '16px',
        padding: '5px 25px',
        '@media (max-width: 372px)': {
            padding: '5px 8px',
            fontSize: '12px',
        },
        '@media (min-width:375px) and (max-width: 600px)': {
            padding: '5px 15px',
            fontSize: '12px',
        },
        [theme.breakpoints.up('sm')]: {
            padding: '5px 15px',
            fontSize: '14px',
        },
        [theme.breakpoints.up('md')]: {
            padding: '5px 25px',
            fontSize: '16px',
        },
        '&:focus,&:hover': {
            outline: 'none',
        },
    },
    greybutton: {
        marginLeft: theme.spacing(2),
        borderRadius: 20,
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-medium',
        fontSize: '1rem',
        padding: '5px 15px',
        '@media (max-width: 372px)': {
            padding: '5px 8px',
            fontSize: '12px',
            marginLeft: theme.spacing(1),
        },
        '@media (min-width:373px) and (max-width: 600px)': {
            padding: '5px 16px',
            fontSize: '12px',
            marginLeft: theme.spacing(1),
        },

        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '16px',
        },
        '&:focus,&:hover': {
            outline: 'none',
        },
    },

    footer: {
        backgroundColor: '#ECECEC',
        position: 'fixed',
        bottom: 0,
        zIndex: 12,
        height: '80px',
        justifyContent: 'flex-end',
        [theme.breakpoints.down('xs')]: {
            height: '115px',
            justifyContent: 'center',
        },
    },
    table: {
        minWidth: 650,
    },
    prefernceRow: {
        backgroundColor: theme.palette.grey[200],
        minHeight: 42,
        textAlign: 'center',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        fontFamily: 'gt-walsheim-medium',
        fontSize: '1rem',
    },
    tableRow: {
        backgroundColor: theme.palette.grey[200],
        minHeight: 42,
    },
    tableHeader: {
        minHeight: 40,
        fontFamily: 'gt-walsheim-medium',
    },
    prefernceHeader: {
        minHeight: 37,
        fontFamily: 'gt-walsheim-medium',
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
            marginTop: theme.spacing(1.2),
        },
    },
    contactGroupNames: {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            fontSize: '13px',
            marginTop: theme.spacing(1),
            marginLeft: theme.spacing(1),
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
            marginLeft: theme.spacing(1),
        },
    },
    permissionToolTip: {
        marginLeft: theme.spacing(1),
        marginTop: '4px',
    },
    centerAlign: {
        textAlign: 'center',
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
    },
    rightAlign: {
        textAlign: 'right',
    },
    formLabelColor: {
        color: 'rgba(0, 0, 0, 0.87);',
        lineHeight: 1.5,
        marginBottom: 0,
    },
    errorMessage: {
        width: '100%',
        marginTop: '.25rem',
        color: '#f44336',
        display: 'block',
        marginBottom: 0,
    },
    eirCodeLogo: {
        height: '19px',
        paddingLeft: '7px',
        width: 'auto',
        [theme.breakpoints.down('sm')]: {
            height: '12px',
        },
        [theme.breakpoints.up('sm')]: {
            height: '16px',
        },
        [theme.breakpoints.up('md')]: {
            height: '19px',
        },
    },
    eirCodeLink: {
        textDecoration: 'none',
    },
    summaryButton: {
        borderRadius: 30,
        textTransform: 'none',
        textAlign: 'left',
        letterSpacing: '0px',
        fontFamily: 'gt-walsheim-regular',
        fontSize: 18,
        backgroundColor:primaryText,
        fontWeight: 'bold',
        padding: '10px 45px',
        margin: '17px 81px 0px 20px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            margin: '0px',
        },
        [theme.breakpoints.up('sm')]: {
            fontSize: '16px',
            marginTop: '20px',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '18px',
            margin: '17px 81px 0px 20px',
        },
        '&:focus,&:hover': {
            outline: 'none',
            backgroundColor:primaryText,
        },
    },
    summaryLabel: {
        fontSize: '24px',
        fontFamily: 'gt-walsheim-medium',
        color: primaryText,
        paddingTop: '20px',
        margin: theme.spacing(1, 2),
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            margin: theme.spacing(0),
            paddingTop: '10px',
        },
        [theme.breakpoints.up('sm')]: {
            marginTop: '8px',
        },
    },
    whiteCheckbox: {
        '&:not($checked) .MuiIconButton-label:after': {
            content: '""',
            left: 4,
            top: 4,
            height: 15,
            width: 15,
            position: 'absolute',
            backgroundColor: 'white',
            zIndex: -1,
        },
        color: 'grey',
        '& .MuiIconButton-label': {
            position: 'relative',
            zIndex: 0,
        },
        [theme.breakpoints.down('sm')]: {
            '&:not($checked) .MuiIconButton-label:after': {
                content: '""',
                left: 4,
                top: 4,
                height: 13,
                width: 13,
                position: 'absolute',
                backgroundColor: 'white',
                zIndex: -1,
            },
        },
    },
    preferenceName: {
        fontSize: '13px',
        fontFamily: 'gt-walsheim-medium',
        color: 'rgba(0, 0, 0, 0.87);',
        marginTop: '13px',
        [theme.breakpoints.up('sm')]: {
            fontSize: '14px',
        },
    },
    selectLabel: {
        fontSize: '16px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
            minHeight: '30px',
        },
        [theme.breakpoints.up('md')]: {
            fontSize: '14px',
            minHeight: '35px',
        },
    },
    checkoutH1: {
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            marginTop: '20px',
        },
    },
}));
